export const userAgent = () => {
  const userAgent = navigator.userAgent || navigator.vendor;

  const isFacebook = /\bFB[\w_]+\//.test(userAgent);
  const isInstagram = /\bInstagram/i.test(userAgent);
  const isAndroid = /android/i.test(userAgent);
  const isIos = /iPad|iPhone|iPod/.test(userAgent);

  return { isFacebook, isInstagram, isAndroid, isIos };
};
